import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
export const useTripTypes = () => {
  const [t, setT] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/public/trip-types").then((r) => { cache = r.data; setT(r.data); });
  }, []);
  return t || {};
};

export const earliestDate = (months) => {
  const d = new Date(Date.now() + (months * 30 + 1) * 86400000);
  return d.toISOString().slice(0, 10);
};
export const latestDate = () => new Date(Date.now() + 729 * 86400000).toISOString().slice(0, 10);
export const windowText = (tt) => (tt ? `Book ${tt.min}–${tt.max} months out` : "");
